<be-dialog-shell [title]="title" (close)="closeDialog()" [closeButton]="!saving">
    <form autocomplete="off" (submit)="$event.preventDefault();" [formGroup]="formGroup">
        <div class="campos-principales">
            <div class="campo">
                <label>Nombre de la clínica</label>
                <mat-form-field>
                    <input formControlName="denominacionSocial" matInput>
                    <mat-error *ngIf="formGroup.get('denominacionSocial').hasError('required')">El nombre es
                        obligatorio.
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="campo">
                <label>CIF/NIF</label>
                <mat-form-field>
                    <input formControlName="cifNif" matInput>
                </mat-form-field>
            </div>
            <div class="campo">
                <label>Email</label>
                <mat-form-field>
                    <input formControlName="email" matInput>
                    <mat-error *ngIf="formGroup.get('email').hasError('email')">No parece una dirección de correo
                        válida.
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </form>

    <div class="direcciones">
        <h3>Direcciones</h3>
        <div *ngIf="direcciones.length > 0; else sinDirecciones">
            <div class="tabla-scroll" arrastrarScroll>
                <table>
                    <tr>
                        <th>Calle</th>
                        <th>Población</th>
                        <th>CP</th>
                        <th>Provincia</th>
                        <th>País</th>
                        <th></th>
                    </tr>
                    <tr *ngFor="let direccion of direcciones; let i = index">
                        <td>{{ direccion.calle }}</td>
                        <td>{{ direccion.poblacion }}</td>
                        <td>{{ direccion.cp }}</td>
                        <td>{{ nombreProvincia(direccion) }}</td>
                        <td>{{ nombrePais(direccion) }}</td>
                        <td>
                            <button type="button" mat-icon-button [disabled]="addAddress"
                                    (click)="editarDireccionLocal(direccion, i)">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button type="button" mat-icon-button [disabled]="addAddress"
                                    (click)="borrarDireccionLocal(i)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <ng-template #sinDirecciones>
            <p>Todavía no hay ninguna dirección para esta clínica.</p>
        </ng-template>

        <button type="button" mat-raised-button *ngIf="!addAddress" (click)="nuevaDireccion()">
            Añadir dirección
        </button>

        <div *ngIf="addAddress" class="form-edicion">
            <h4>{{ tempAddressId === -1 ? 'Nueva dirección' : 'Editar dirección' }}</h4>
            <form autocomplete="off" (submit)="$event.preventDefault();" [formGroup]="tempAddressForm">
                <div class="newForm">
                    <app-direccion-form [formGroup]="tempAddressForm"></app-direccion-form>
                </div>
            </form>
            <div class="botones_edicion">
                <button type="button" mat-button color="warn" (click)="cancelarDireccion()">Cancelar</button>
                <button type="button" mat-raised-button color="primary" [disabled]="tempAddressForm.invalid"
                        (click)="guardarDireccionLocal()">
                    {{ tempAddressId === -1 ? 'Añadir a la lista' : 'Actualizar en la lista' }}
                </button>
            </div>
        </div>
    </div>

    <div class="telefonos">
        <h3>Teléfonos</h3>
        <div *ngIf="telefonos.length > 0; else sinTelefonos">
            <div class="tabla-scroll" arrastrarScroll>
                <table>
                    <tr>
                        <th>Departamento</th>
                        <th>Código de país</th>
                        <th>Teléfono</th>
                        <th>Extensión</th>
                        <th></th>
                    </tr>
                    <tr *ngFor="let telefono of telefonos; let i = index">
                        <td>{{ telefono.departamento }}</td>
                        <td>{{ telefono.codigoArea }}</td>
                        <td>{{ telefono.telefono }}</td>
                        <td>{{ telefono.extension }}</td>
                        <td>
                            <button type="button" mat-icon-button [disabled]="addPhone"
                                    (click)="editarTelefonoLocal(telefono, i)">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button type="button" mat-icon-button [disabled]="addPhone"
                                    (click)="borrarTelefonoLocal(i)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <ng-template #sinTelefonos>
            <p>Todavía no hay ningún teléfono para esta clínica.</p>
        </ng-template>

        <button type="button" mat-raised-button *ngIf="!addPhone" (click)="nuevoTelefono()">
            Añadir teléfono
        </button>

        <div *ngIf="addPhone" class="form-edicion">
            <h4>{{ tempPhoneId === -1 ? 'Nuevo teléfono' : 'Editar teléfono' }}</h4>
            <form autocomplete="off" (submit)="$event.preventDefault();" [formGroup]="tempPhoneForm">
                <div class="newForm">
                    <mat-form-field>
                        <mat-label>Código de país</mat-label>
                        <input formControlName="codigoArea" matInput>
                        <mat-error *ngIf="tempPhoneForm.get('codigoArea').hasError('required')">El código de país
                            es obligatorio.
                        </mat-error>
                        <mat-error *ngIf="tempPhoneForm.get('codigoArea').hasError('maxlength')">No existen códigos
                            de área con más de 3 cifras.
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Teléfono</mat-label>
                        <input formControlName="telefono" matInput>
                        <mat-error *ngIf="tempPhoneForm.get('telefono').hasError('required')">Al menos el teléfono
                            es necesario.
                        </mat-error>
                        <mat-error
                                *ngIf="tempPhoneForm.get('telefono').hasError('minlength') || tempPhoneForm.get('telefono').hasError('maxlength')">
                            El teléfono debe tener 9 cifras.
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Extensión</mat-label>
                        <input formControlName="extension" matInput>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Departamento</mat-label>
                        <input formControlName="departamento" matInput>
                    </mat-form-field>
                </div>
            </form>
            <div class="botones_edicion">
                <button type="button" mat-button color="warn" (click)="cancelarTelefono()">Cancelar</button>
                <button type="button" mat-raised-button color="primary" [disabled]="tempPhoneForm.invalid"
                        (click)="guardarTelefonoLocal()">
                    {{ tempPhoneId === -1 ? 'Añadir a la lista' : 'Actualizar en la lista' }}
                </button>
            </div>
        </div>
    </div>

    <dialog-actions>
        <button mat-button (click)="closeDialog()" [disabled]="saving">Cancelar</button>
        <button mat-flat-button color="primary" [disabled]="saving || formGroup.invalid" (click)="guardar()">
            <mat-icon>save</mat-icon>
            Guardar
        </button>
    </dialog-actions>
</be-dialog-shell>
